import type { TabSliderForm } from "./tab-slider-form";

export class TabSliderHandler {
    public form: TabSliderForm;

    public constructor(form: TabSliderForm) {
        this.form = form;
    }

    public bootstrap(): void {
        this.updateNavState();
        this.scrollActiveIntoView("auto");
    }

    public handlePrevClick(event: Event): void {
        event.preventDefault();
        this.scrollByPage(-1);
    }

    public handleNextClick(event: Event): void {
        event.preventDefault();
        this.scrollByPage(1);
    }

    public handleTrackScroll(): void {
        this.updateNavState();
    }

    public handleTrackClick(event: Event): void {
        const tab = this.form.getClosestTab(event.target);
        if (!(tab instanceof HTMLElement)) return;

        requestAnimationFrame(() => {
            tab.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center",
            });
        });
    }

    public handleMutations(): void {
        this.updateNavState();
        this.scrollActiveIntoView("smooth");
    }

    public handleResize(): void {
        this.updateNavState();
    }

    public scrollByPage(direction: number): void {
        const track = this.form.getTrack();
        if (!(track instanceof HTMLElement)) return;

        const step = Math.max(120, Math.round(track.clientWidth * 0.8));
        track.scrollBy({
            left: direction * step,
            behavior: "smooth",
        });
    }

    public scrollActiveIntoView(behavior: ScrollBehavior = "smooth"): void {
        const active = this.form.getActiveTab();
        if (!(active instanceof HTMLElement)) return;

        active.scrollIntoView({
            behavior,
            block: "nearest",
            inline: "center",
        });
    }

    public updateNavState(): void {
        const root = this.form.getRoot();
        const track = this.form.getTrack();
        const prevButton = this.form.getPrevButton();
        const nextButton = this.form.getNextButton();
        if (!(track instanceof HTMLElement)) return;
        if (!(prevButton instanceof HTMLButtonElement)) return;
        if (!(nextButton instanceof HTMLButtonElement)) return;

        const maxScrollLeft = Math.max(0, track.scrollWidth - track.clientWidth);
        const canScroll = maxScrollLeft > 1;
        root.classList.toggle("is-static", !canScroll);

        if (!canScroll) {
            prevButton.disabled = true;
            nextButton.disabled = true;
            return;
        }

        prevButton.disabled = track.scrollLeft <= 1;
        nextButton.disabled = track.scrollLeft >= maxScrollLeft - 1;
    }
}
